(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["judgeme-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const AUTO_SCROLL_INTERVAL_MS = 10000;
    const HARVEST_SETTLE_MS = 600;
    const HARVEST_TIMEOUT_MS = 15000;
    const ARROW_SVG =
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function buildSlide(index, contentNode) {
      const slide = document.createElement('slideshow-slide');
      slide.setAttribute('ref', 'slides[]');
      slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      slide.className = 'judgeme-reviews__slide';
      slide.style.setProperty('--slideshow-timeline', `--slide-${index}`);
      slide.appendChild(contentNode);
      return slide;
    }

    function buildArrow(direction, label) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `judgeme-carousel-arrow judgeme-carousel-arrow--${direction}`;
      button.setAttribute('on:click', `/${direction === 'prev' ? 'previous' : 'next'}`);
      button.setAttribute('aria-label', label);
      button.innerHTML = ARROW_SVG;
      return button;
    }

    function buildCarousel(reviewNodes) {
      const component = document.createElement('slideshow-component');
      component.className = 'judgeme-reviews__slideshow slideshow--stretch-content';
      component.style.setProperty('--slideshow-align-items', 'stretch');
      component.setAttribute('initial-slide', '0');
      component.setAttribute('infinite', '');

      const container = document.createElement('slideshow-container');
      container.setAttribute('ref', 'slideshowContainer');

      const scroller = document.createElement('slideshow-slides');
      scroller.setAttribute('ref', 'scroller');
      scroller.setAttribute('tabindex', '-1');

      reviewNodes.forEach((node, i) => scroller.appendChild(buildSlide(i, node)));

      container.appendChild(scroller);
      component.appendChild(container);

      const nav = document.createElement('div');
      nav.className = 'judgeme-reviews__nav';
      nav.appendChild(buildArrow('prev', 'Previous reviews'));
      nav.appendChild(buildArrow('next', 'Next reviews'));
      component.appendChild(nav);

      return component;
    }

    function startAutoScroll(carousel) {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let stoppedForGood = prefersReducedMotion;

      function stopAutoScrollPermanently() {
        stoppedForGood = true;
        carousel.pause?.();
      }

      function maybeStart() {
        if (stoppedForGood || typeof carousel.play !== 'function') return;
        const scroller = carousel.querySelector('slideshow-slides');
        if (!scroller || scroller.scrollWidth <= scroller.clientWidth + 1) return;
        carousel.play(AUTO_SCROLL_INTERVAL_MS);
      }

      carousel.addEventListener('slideshow:select', (event) => {
        if (event.detail?.userInitiated) stopAutoScrollPermanently();
      });
      carousel.addEventListener('mouseenter', () => carousel.suspend?.());
      carousel.addEventListener('mouseleave', maybeStart);
      carousel.addEventListener('focusin', () => carousel.suspend?.());
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) maybeStart();
      });
      window.addEventListener('resize', maybeStart, { passive: true });

      carousel.judgemeReviewsCleanup = stopAutoScrollPermanently;

      maybeStart();
    }

    function harvestReviews(sourceRoot, onReady) {
      let settled = false;
      let debounceTimer = null;

      function trySettle() {
        if (settled) return;
        const nodes = Array.from(sourceRoot.querySelectorAll('.jdgm-rev'));
        if (!nodes.length) return;
        settled = true;
        observer.disconnect();
        clearTimeout(overallTimeout);
        onReady(nodes);
      }

      const observer = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(trySettle, HARVEST_SETTLE_MS);
      });
      observer.observe(sourceRoot, { childList: true, subtree: true });

      const overallTimeout = setTimeout(() => {
        if (settled) return;
        observer.disconnect();
        trySettle();
      }, HARVEST_TIMEOUT_MS);

      trySettle();
    }

    function initSection(section) {
      if (section.dataset.judgemeReviewsInitialized) return;
      section.dataset.judgemeReviewsInitialized = 'true';

      const mount = section.querySelector('[data-judgeme-carousel-mount]');
      const source = section.querySelector('[data-judgeme-source]');
      const writeButton = section.querySelector('[data-judgeme-write-review]');
      if (!mount || !source) return;

      writeButton?.addEventListener('click', () => {
        const trigger = source.querySelector(
          '.jdgm-write-rev-link, [class*="write-rev"], [class*="write-review"]'
        );
        trigger?.click();
      });

      harvestReviews(source, (reviewNodes) => {
        if (!mount.isConnected || mount.childElementCount) return;
        const carousel = buildCarousel(reviewNodes);
        mount.appendChild(carousel);
        customElements.upgrade(carousel);
        startAutoScroll(carousel);
      });
    }

    function initAll(root = document) {
      root.querySelectorAll('[data-judgeme-reviews-section]').forEach(initSection);
    }

    function cleanupAll(root) {
      root.querySelectorAll('.judgeme-reviews__slideshow').forEach((carousel) => {
        carousel.judgemeReviewsCleanup?.();
      });
    }

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => cleanupAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const AUTO_SCROLL_INTERVAL_MS = 10000;

    // Slide navigation and its animation are handled entirely by the native
    // <slideshow-component> (see assets/slideshow.js): the arrow buttons'
    // on:click="/previous" / on:click="/next" attributes (slideshow-arrow.liquid)
    // already call carousel.previous()/next(), which animate via the same
    // scroll-snap-safe smooth scroll used by every other carousel in this
    // theme, honour prefers-reduced-motion automatically, and - because the
    // slideshow is rendered with infinite: true - loop continuously. This
    // script only adds autoplay and the "stop for good after a manual
    // interaction" rule on top of that native behaviour.
    function initCarouselNav(carousel) {
      if (carousel.dataset.reviewsNavInitialized) return;
      carousel.dataset.reviewsNavInitialized = 'true';

      customElements.upgrade(carousel);

      const scroller = carousel.querySelector('slideshow-slides');
      const nav = carousel.querySelector('.reviews-list__nav');
      const previous = nav?.querySelector('.slideshow-control--previous');
      const next = nav?.querySelector('.slideshow-control--next');
      if (!scroller || !previous || !next) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Once true, auto-scroll never restarts for the rest of this page visit.
      let stoppedForGood = prefersReducedMotion;

      function hasOverflow() {
        return scroller.scrollWidth > scroller.clientWidth + 1;
      }

      function stopAutoScrollPermanently() {
        stoppedForGood = true;
        carousel.pause?.();
      }

      function updateControlsState() {
        const overflowing = hasOverflow();
        // Nothing to page through - disable controls, nothing to auto-scroll either.
        previous.disabled = !overflowing;
        next.disabled = !overflowing;

        if (!overflowing || stoppedForGood || typeof carousel.play !== 'function') return;
        carousel.play(AUTO_SCROLL_INTERVAL_MS);
      }

      // Any user-initiated navigation - arrow click, swipe/drag, or manual
      // scroll - permanently stops auto-scroll. carousel.pause() sets the
      // native `paused` state, so the built-in mouseleave/focusout resume()
      // call further down refuses to restart it afterwards.
      carousel.addEventListener('slideshow:select', (event) => {
        if (event.detail?.userInitiated) stopAutoScrollPermanently();
      });

      carousel.addEventListener('mouseenter', () => carousel.suspend?.());
      carousel.addEventListener('mouseleave', updateControlsState);
      carousel.addEventListener('focusin', () => carousel.suspend?.());
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) updateControlsState();
      });

      window.addEventListener('resize', updateControlsState, { passive: true });

      carousel.reviewsCarouselCleanup = stopAutoScrollPermanently;

      updateControlsState();
    }

    function initAll(root = document) {
      root.querySelectorAll('.reviews-list__slideshow').forEach(initCarouselNav);
    }

    function cleanupAll(root) {
      root.querySelectorAll('.reviews-list__slideshow').forEach((carousel) => {
        carousel.reviewsCarouselCleanup?.();
      });
    }

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => cleanupAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
